import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button, Container, Row, Col, Table, FormControl, FormLabel, Alert } from 'react-bootstrap';
import { logout } from "./actions/auth.js";
import { useSelector } from "react-redux";
import UserDataService from "./services/user.serviceaux.js";
import Sidebar from "./Sidebar.js";
import ExportSidebar from './ProSideBar.js';
import { useParams } from "react-router-dom";
import OrganigramaAreaDataService from './services/organigramaarea.service';
import { dtFormatter, PageHeader } from './AuxiliaryFunctions';
import CompetenciasAreasJuez from './CompetenciasAreasJuez';

const Title = styled.h2`
  text-align: center;
  margin-bottom: 1rem;
`;

const SectionTitle = styled.h3`
  margin-top: 2rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  margin-bottom: 0.5rem;
  font-weight: bold;
`;

const Input = styled.input`
  padding: 0.6rem;
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
`;


const Message = styled.p`
  color: green;
  margin-top: 1rem;
  text-align: center;
`;

// Example styles
const styles = {
  container: {
    width: '100%',
    margin: 'auto auto',
    padding: '1rem',
    border: '1px solid #ccc',
    borderRadius: '8px',
    textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
  },
  avatar: {
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    objectFit: 'cover',
    marginBottom: '1rem',
  },
};


const ViewUserProfile = (props) => {
  let params = useParams();
  const [profile, setProfile] = useState({});
  const profileid = params ? params.userid : null;
  const { user: currentUser } = useSelector((state) => state.auth);

  const [showerror, setShowerror] = useState(false);
  const [showsuccess, setShowsuccess] = useState(false);
  const [errmessage, setErrmessage] = useState('');
  const [succmessage, setSuccmessage] = useState('');

  const [listofcompetenciasusuario, setListofJCompetenciasUsuario] = useState([]);  
  const [roles, setRoles] = useState([]);

  useEffect(()=> {
    UserDataService.get(profileid) 
    .then(resp => {
      let respdata = resp.data[0];
      //respdata.roles = respdata.roles.map(rol => rol.id);
      setProfile(respdata);
      setRoles(respdata.roles);
    })
    .catch(err => {
      console.log(err);
    });

    OrganigramaAreaDataService.getListCompetenciasUsuario(profileid)
      .then(resp => {
        console.log(resp.data);
        setListofJCompetenciasUsuario(resp.data);
      })
      .catch((e) => {
        if (e.response.status == 401) {
          dispatch(logout())
          .then(() => {
            window.location.reload();
          });
        }
        else {
          console.log(e.response.data);
          setSuccmessage("");
          setShowsuccess(false);
          setErrmessage(e);
          setShowerror(true);
        }
      });        
  }, [])

  return (
    <>
    <Sidebar />
    <div style={{display:'flex', flexDirection:'row', gap:'20px'}}>      
      <ExportSidebar roles={currentUser.roles}/>
      <div style={{display:'block',width:'100%'}}>
        <Container style={{width:"80%"}}>
          <PageHeader />
          <Container>
            <h4 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Perfil de {profile.primernombre}</h4>
          </Container>
          <Row>
          <div
            className="card"
            style={{padding:'40px 40px',}}
          >
        
              <div style={{display:'flex',flexDirection:'column',gap:'0px',flexWrap:'wrap'}}>                
                <div style={styles.container}>
                  <img src={"//ssl.gstatic.com/accounts/ui/avatar_2x.png"} alt={`${(profile.primerapellido + ' ' + (profile.segundoapellido?profile.segundoapellido:"")).trim() + ", " + (profile.primernombre + ' ' + (profile.segundonombre?profile.segundonombre:"")).trim()}'s avatar`} style={styles.avatar} />
                  <h2>{(profile.primerapellido + ' ' + (profile.segundoapellido?profile.segundoapellido:"")).trim() + ", " + (profile.primernombre + ' ' + (profile.segundonombre?profile.segundonombre:"")).trim()}</h2>
                </div>
                <div style={{display:'flex',flexDirection:'row',gap:'10px',flexWrap:'wrap'}}>
                  <label><strong>Nombre:</strong></label>
                  <label>{(profile.primerapellido + ' ' + (profile.segundoapellido?profile.segundoapellido:"")).trim() + ", " + (profile.primernombre + ' ' + (profile.segundonombre?profile.segundonombre:"")).trim()}</label>
                </div>

                <div style={{display:'flex',flexDirection:'row',gap:'10px'}}>
                  <label><strong>Correo electrónico:</strong></label>
                  <label>{profile.email}</label>
                </div>

                <div style={{display:'flex',flexDirection:'row',gap:'10px'}}>
                  <label><strong>Bio:</strong></label>
                  <label>{profile.bio}</label>
                </div>

                <div style={{display:'flex',flexDirection:'row',gap:'10px'}}>
                  <label><strong>Roles de usuario:</strong></label>
                  {(roles.map(rol => {
                    return (
                      <label>{rol.rolename}</label>  
                    )
                  }))}
                </div>

              </div>  
              <hr/>

              <div>
                <h5>Competencias</h5>
                <ListaCompUsuario listOf={listofcompetenciasusuario} currentUser={currentUser}/>
              </div>
          </div>
          </Row>

          <Row>
            

          </Row>

          <Row className='mt-2'>
          {showerror && (
            <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
              <Alert.Heading>Error</Alert.Heading>
              <p>{errmessage}</p>
            </Alert>      
          )}
          {showsuccess && (
            <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
              <Alert.Heading>Hecho</Alert.Heading>
              <p>{succmessage}</p>
            </Alert>      
          )} 
          </Row>                  
        </Container>
      </div>
    </div>
    </>
  );
};

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>Competencia</th>
        <th className='d-none d-sm-table-cell' style={{width:'20%'}}>Descripción competencia</th>
        <th style={{width:'8%'}}>Fecha inicio</th>
        <th className='d-none d-sm-table-cell' style={{width:'8%'}}>Fecha fin</th>
        <th style={{width:'8%'}}>Ver áreas</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {  
  
  if (props.listOf) {
    
    const rows = props.listOf.map((row, index) => { 
      return (
        <>
        <tr key={index}>        
          <td>
            {row.nombrecompetencia}
          </td>
          <td className='d-none d-sm-table-cell'>
            {row.descripcioncompetencia}
          </td>          
          <td>  
            {dtFormatter(new Date(row.fechainicio),1)}
          </td>
          <td className='d-none d-sm-table-cell' >  
            {dtFormatter(new Date(row.fechafin),1)}
          </td>   
          <td>
            <CompetenciasAreasJuez 
              organigramaid={row.id}  // organigramaId
              competenciaid={row.compid} 
              userid={props.currentUser.id}
            />
          </td>
        </tr>
        </>      
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const ListaCompUsuario = (props) => {        
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader/>
            <TableBody listOf={props.listOf} currentUser={props.currentUser}/>
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
};


export default ViewUserProfile;